import type { MetaConnectionStatus } from "../types";

export type MetaConnectResponse = {
  url?: string | null;
  configured?: boolean;
  message?: string | null;
  error?: string | null;
};

export const getMetaWebhookUrl = (supabaseUrl?: string) => {
  if (!supabaseUrl) return null;
  return `${supabaseUrl.replace(/\/$/, "")}/functions/v1/meta_lead_webhook`;
};

export const getMetaConnectionStatusLabel = (
  translate: (key: string, options?: Record<string, unknown>) => string,
  status: MetaConnectionStatus,
) => {
  const labels: Record<MetaConnectionStatus, string> = {
    pending: "Pending",
    connected: "Connected",
    "needs-review": "Needs review",
    error: "Error",
    disabled: "Disabled",
  };
  const key = `crm.settings.integrations.meta.status_${status.replace(
    /-/g,
    "_",
  )}`;
  return translate(key, { _: labels[status] });
};
